module.exports = __webpack_public_path__ + "img/fig07.4d63ee24.jpg";